module.exports = " <div class=\"message-template clearfix\"> <div class=person-icon></div> <div class=message-container> <div class=triangle></div> <div class=message> <div class=message-header>您是否想咨询以下问题？</div> <div class=split-line></div> <div class=message-body> <ul> <li v-for=\"item in content\"> <a href=javascript:void(0); @click=querySelected(item.title)>{{item.title}}</a> </li> </ul> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/ManyIssues.vue
// module id = 58
// module chunks = 1